import React, { createContext, useState } from "react";
const UserContext = createContext();

export const UserStore = (props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [refreshToken, setRefreshToken] = useState("");
  const [username, setUsername] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [btnSpinner, setBtnSpinner] = useState(false);

  return (
    <UserContext.Provider
      value={{
        isLoggedIn,
        setIsLoggedIn,
        accessToken,
        setAccessToken,
        refreshToken,
        setRefreshToken,
        username,
        setUsername,
        isLoading,
        setIsLoading,
        btnSpinner,
        setBtnSpinner,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContext;
